import { Check } from '@huspy/briks-icons';
import { Flex, Text } from '@huspy/briks-web';
import { VStack } from '@huspy/styled-system/jsx';
import { useTranslation } from 'react-i18next';

const baseTranslation = 'opportunity.caseSubmission.submitApplications.bankAndHuspySubmission.successMessage';

export const SuccessMessage = ({ isSubmittedToBank }: {
  isSubmittedToBank: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <VStack gap='4' alignItems='center' justify='center' h='100%'>
      <Flex
        justify='center'
        align='center'
        p='2'
        borderRadius='50%'
        bg='success.500'
        w='120px'
        h='120px'
      >
        <Check color='white' height='56px' width='56px' />
      </Flex>
      <Text size='4xl' fontWeight='semibold'>
        {t(`${baseTranslation}.title`)}
      </Text>
      <Text size='lg' color='neutral.500'>
        {t(
          `${baseTranslation}.${isSubmittedToBank ? 'bankSubmissionDescription' : 'huspySubmissionDescription'}`
        )}
      </Text>
      <Text size='lg' fontWeight='semibold' color='blue.900'>
        {t(`${baseTranslation}.finale`)}
      </Text>
    </VStack>
  );
};
